import { objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';

function _await(value, then, direct) {
  if (direct) {
    return then ? then(value) : value;
  }
  if (!value || !value.then) {
    value = Promise.resolve(value);
  }
  return then ? value.then(then) : value;
}
function _async(f) {
  return function () {
    for (var args = [], i = 0; i < arguments.length; i++) {
      args[i] = arguments[i];
    }
    try {
      return Promise.resolve(f.apply(this, args));
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
var script = {
  name: 'ColorPickerSaturation',
  props: {
    color: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 138
    },
    width: {
      type: Number,
      default: 184
    }
  },
  data() {
    return {
      cursor: {},
      canvas: {},
      ctx: null
    };
  },
  watch: {
    color() {
      this.setCanvasBackground();
      this.handleValueChange();
    }
  },
  mounted: _async(function () {
    const _this = this;
    return _await(_this.$nextTick(), function () {
      _this.initCanvas();
      _this.handleValueChange();
    });
  }),
  methods: {
    initCanvas() {
      this.ctx = this.$refs.canvas.getContext('2d');
      this.canvas = this.$refs.canvas.getBoundingClientRect();
      this.setCanvasBackground();
    },
    handleValueChange() {
      const {
        width,
        height
      } = this.canvas;
      const x = this.color.hsv.s / 100 * width;
      const y = (100 - this.color.hsv.v) / 100 * height;
      this.cursor = {
        x,
        y
      };
    },
    updateCursorPosition(_ref) {
      let {
        x,
        y
      } = _ref;
      const {
        left,
        top,
        width,
        height
      } = this.canvas;
      const normalized = {
        x: Math.min(Math.max(x - left, 0), width),
        y: Math.min(Math.max(y - top, 0), height)
      };
      this.cursor = normalized;
      this.updateColor();
    },
    updateColor() {
      const {
        x,
        y
      } = this.cursor;
      const {
        width,
        height
      } = this.canvas;
      const saturation = x * 100 / width;
      const bright = 100 - y * 100 / height;
      this.$emit('change', _objectSpread2(_objectSpread2({}, this.color.hsv), {}, {
        s: Math.round(saturation),
        v: Math.round(bright)
      }));
    },
    setCanvasBackground() {
      const {
        width,
        height
      } = this.canvas;
      this.ctx.clearRect(0, 0, width, height);
      this.ctx.fillStyle = `hsl(${this.color.hsv.h}, 100%, 50%)`;
      this.ctx.fillRect(0, 0, width, height);
      const gradientWhite = this.ctx.createLinearGradient(0, 0, width, 0);
      gradientWhite.addColorStop(0, 'hsl(0, 0%, 100%)');
      gradientWhite.addColorStop(1, 'hsla(0, 0%, 100%, 0)');
      this.ctx.fillStyle = gradientWhite;
      this.ctx.fillRect(0, 0, width, height);
      const gradientBlack = this.ctx.createLinearGradient(0, 0, 0, height);
      gradientBlack.addColorStop(0, 'hsla(0, 0%, 0%, 0)');
      gradientBlack.addColorStop(1, 'hsl(0, 0%, 0%)');
      this.ctx.fillStyle = gradientBlack;
      this.ctx.fillRect(0, 0, width, height);
    },
    handleMouseDown(_ref2) {
      let {
        clientX,
        clientY
      } = _ref2;
      this.canvas = this.$refs.canvas.getBoundingClientRect();
      this.updateCursorPosition({
        x: clientX,
        y: clientY
      });
      const handleMouseMove = evnt => {
        window.requestAnimationFrame(() => {
          this.updateCursorPosition({
            x: evnt.clientX,
            y: evnt.clientY
          });
        });
      };
      const handleMouseUp = () => {
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
      };
      document.addEventListener('mousemove', handleMouseMove);
      document.addEventListener('mouseup', handleMouseUp);
    }
  }
};

export { script as default };
//# sourceMappingURL=color-picker-saturation.vue2.js.map
